import { useContext } from 'react'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPlus } from '@fortawesome/pro-light-svg-icons'

import {
  Box, Button, DashboardModule,
} from '@domain-group/suit-theme'

import PageContext from '@contexts/pageContext'
import type { DefaultContext } from '@contexts/pageContext'

import type {
  PageContextPayload,
} from '@sections/Admin/packs/QualityControl/screens/TaskListTemplate/screens/Edit/screens/Details'

import type { TaskListTemplateModel } from '@models/taskListTemplate'

import useAttachment from '@hooks/useAttachment'
import useAttachments from '@hooks/useAttachments'

import AttachmentListItem from '@components/AttachmentListItem'

interface AssetsProps {
  taskListTemplate: TaskListTemplateModel,
}

const Assets = (props: AssetsProps) => {
  const { taskListTemplate } = props

  // @ts-expect-error TS2345
  const pageContext = useContext<DefaultContext<PageContextPayload>>(PageContext)
  const {
    callbacks: {
      deleteAttachment,
    },
  } = pageContext

  const attachmentsPayload = useAttachments({
    filters: {
      attachable_type: 'TaskListTemplate',
      attachable_id: taskListTemplate.id,
    },
    performHttpRequests: !!taskListTemplate.id,
  })

  const {
    filteredAttachments,
    hasFilteredAttachments,
    loading,
  } = attachmentsPayload

  // Task List Attachments
  const taskListAttachmentPayload = useAttachment({
    attachable_type: 'TaskListTemplate',
    attachable_id: taskListTemplate.id,
  })

  const {
    callbacks: { uploadAttachment },
  } = taskListAttachmentPayload

  return (
    <DashboardModule
      contentBoxProps={{ flexDirection: 'column' }}
      title="Assets"
    >
      <Box flexDirection="column">
        {filteredAttachments.map(attachment => (
          <AttachmentListItem attachment={attachment} callbacks={{ deleteAttachment }} key={attachment.id} />
        ))}
      </Box>

      <DashboardModule.Footer boxProps={{ borderTop: loading || !hasFilteredAttachments ? 'none' : '1px solid' }}>
        <Button
          buttonStyle="secondaryEdit"
          icon={<FontAwesomeIcon icon={faPlus} />}
          onClick={() => uploadAttachment()}
          marginLeft="auto"
          // @ts-expect-error TS2322
          size={['medium', 'small']}
          width={['100%', 'fit-content']}
        >
          Upload Asset
        </Button>
      </DashboardModule.Footer>
    </DashboardModule>
  )
}

export default Assets
